export default __webpack_public_path__ + "static/cards-diagram-dark-a98bf6519a9dc358503f3259342cee1a.png";